import configs from './config.json';

export class Converts{
    static convertImgSrc=(src)=>{
        return `${configs.server.Storage}/${src}`
    }
    static toTimestamp = strDate => Date.parse(strDate);

    static convertPersianDateToUniversal=(date)=>{
        return new Date(this.toTimestamp(date)).toLocaleDateString("en-US")
    }
    static formatNumber = (num,div=",")=>{
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, div);
    }

    static covertUniversalDateToPersianData = (date) => {
        return new Date(date).toLocaleDateString('fa-IR')
    }

    static types=['','1','2','3','4'];
}

export class Utils {
    static sleep = (ms) => new Promise((r) => setTimeout(r, ms));
}